'use client';

import { Box } from '@mui/material';
import { H2 } from '@web/components/Typography';
import ProductListMobile from '@web/components/product-list/ProductListMobile';
import { useParams } from 'next/navigation';
import useSWR from 'swr';
import fetcher from '@web/utils/fetch';
import { Fragment } from 'react';
import ShowMoreLayout from '@web/components/product-list/ShowMoreLayout';

export default function ProductSuggestions({
  isMobile,
}: {
  isMobile?: boolean;
}) {
  const params = useParams();
  const { data: suggestions }: any = useSWR(
    () => params?.slug && `/api/product/suggestions/${params?.slug}`,
    fetcher
  );

  if (isMobile) {
    return (
      <Box>
        {suggestions?.length > 0 && (
          <Box>
            <H2 fontSize="1.25rem" my={1}>
              You may also like
            </H2>
            <ProductListMobile
              height={280}
              products={suggestions}
              horizontal={true}
            />
          </Box>
        )}
      </Box>
    );
  } else {
    return (
      <Box mb={4}>
        {suggestions?.length > 0 && (
          <Fragment>
            <H2 fontSize="1.25rem" my={2}>
              You may also like
            </H2>
            <ShowMoreLayout products={suggestions} number={6} />
          </Fragment>
        )}
      </Box>
    );
  }
}
